module.exports = __webpack_public_path__ + "img/upload-icon-active.c63d06ed.svg";